<ng-container *ngIf="notificationType == 'info'">
    <div [@notificationVisibility]="isVisible ? 'show' : 'hide'"
         class="notification info lm-notification-container">
        <p
            class="notification-text"
            >{{message}}
            <a *ngIf="actionMessage"
                class="notification-link"
                (click)="handleActionClick()">{{actionMessage}}</a>
        </p>
        <button
                type="text"
                soho-button [icon]="'close'"
                class="notification-close lm-notification-close-btn "
                (click)="handleClose()"></button>
    </div>
</ng-container>

<ng-container *ngIf="notificationType == 'success'">
    <div [@notificationVisibility]="isVisible ? 'show' : 'hide'"
         class="notification success lm-notification-container">
        <p
                class="notification-text"
                style="flex-:1 wrap">{{message}}
            <a *ngIf="actionMessage"
               class="notification-link"
               (click)="handleActionClick()">{{actionMessage}}</a>
        </p>
        <button
                type="text"
                soho-button [icon]="'close'"
                class="notification-close lm-notification-close-btn "
                (click)="handleClose()"></button>
    </div>
</ng-container>

<ng-container *ngIf="notificationType == 'alert'">
    <div [@notificationVisibility]="isVisible ? 'show' : 'hide'"
         class="notification alert lm-notification-container">
        <p
                class="notification-text"
                style="flex-:1 wrap">{{message}}
            <a *ngIf="actionMessage"
               class="notification-link"
               (click)="handleActionClick()">{{actionMessage}}</a>
        </p>
        <button
                type="text"
                soho-button [icon]="'close'"
                class="notification-close lm-notification-close-btn "
                (click)="handleClose()"></button>
    </div>
</ng-container>

<ng-container *ngIf="notificationType == 'error'">
    <div [@notificationVisibility]="isVisible ? 'show' : 'hide'"
         class="notification error lm-notification-container">
        <p
                class="notification-text"
                style="flex-:1 wrap">{{message}}
            <a *ngIf="actionMessage"
               class="notification-link"
               (click)="handleActionClick()">{{actionMessage}}</a>
        </p>
        <button
                type="text"
                soho-button [icon]="'close'"
                class="notification-close lm-notification-close-btn "
                (click)="handleClose()"></button>
    </div>
</ng-container>
